import { api } from "./api";

export async function uploadInChunks(file, purpose, { signal, onProgress, onInitialize } = {}) {
  const { data } = await api.post("/uploads", { filename: file.name, size: file.size, purpose }, { signal });
  onInitialize?.(data.upload_id);
  for (let offset = 0, index = 0; offset < file.size; offset += data.chunk_size, index += 1) {
    const chunk = file.slice(offset, offset + data.chunk_size);
    await api.put(`/uploads/${data.upload_id}/chunks/${index}`, chunk, {
      signal, headers: { "Content-Type": "application/octet-stream" },
      onUploadProgress: (event) => onProgress?.(Math.min(99, Math.round((offset + event.loaded) / file.size * 100))),
    });
  }
  onProgress?.(100);
  return data.upload_id;
}
